export const ACCOUNT_DEACTIVATED_EVENT = "account-deactivated";

let alreadyHandled = false;

export const handleAccountDeactivated = (error) => {
  const res = error?.response;
  const code = res?.data?.error_code || res?.data?.errorCode;
  if (res?.status === 403 && code === "ACCOUNT_DEACTIVATED") {
    if (!alreadyHandled) {
      alreadyHandled = true;
      try {
        window.dispatchEvent(new CustomEvent(ACCOUNT_DEACTIVATED_EVENT));
      } catch (e) {
        try {
          sessionStorage.clear();
        } catch (err) {
          // ignore
        }
        if (window.location.pathname !== "/") {
          window.location.replace("/");
        }
      }
    }
    return true;
  }
  return false;
};
